export default __webpack_public_path__ + "static/media/Bandeau-ressource-vue-RH.25cff415.jpg";